import type { TenantBranchDto, TenantCompanyDto, TenantOrgConfigDto } from '../interfaces/org-config.interface';
import { POLYGON_RESPONSIBLE_BRANCHES } from '../constants/polygon-business.constants';

export function activeBranchNamesFromOrgConfig(catalog: TenantOrgConfigDto | null | undefined): string[] {
  const fromDb = (catalog?.branches ?? [])
    .filter((b) => b.isActive)
    .sort((a, b) => a.sortOrder - b.sortOrder || a.name.localeCompare(b.name, 'cs'))
    .map((b) => b.name.trim())
    .filter(Boolean);
  if (fromDb.length > 0) return fromDb;
  return [...POLYGON_RESPONSIBLE_BRANCHES];
}

export function activeCompaniesFromOrgConfig(catalog: TenantOrgConfigDto | null | undefined): TenantCompanyDto[] {
  return (catalog?.companies ?? [])
    .filter((c) => c.isActive)
    .sort((a, b) => a.sortOrder - b.sortOrder || a.legalName.localeCompare(b.legalName, 'cs'));
}

export function branchByName(
  catalog: TenantOrgConfigDto | null | undefined,
  name: string | null | undefined,
): TenantBranchDto | null {
  const key = String(name ?? '').trim();
  if (!key) return null;
  return (catalog?.branches ?? []).find((b) => b.name.trim() === key) ?? null;
}

export function resolveCompanyIdForBranchName(
  catalog: TenantOrgConfigDto | null | undefined,
  branchName: string | null | undefined,
): string | null {
  return branchByName(catalog, branchName)?.companyId ?? null;
}

/** Kód/slug je u popisku zbytečný (stejný text nebo podřetězec názvu). */
export function isOrgSecondaryCodeRedundant(
  displayName: string | null | undefined,
  code: string | null | undefined,
): boolean {
  const name = String(displayName ?? '').trim();
  const c = String(code ?? '').trim();
  if (!c) return true;
  if (!name) return true;
  const nameLower = name.toLowerCase();
  const codeLower = c.toLowerCase();
  if (nameLower === codeLower) return true;
  return nameLower.includes(codeLower);
}

/** Primární popisek + volitelný kód pro UI (firma / pobočka). */
export function orgEntityDisplayParts(
  displayName: string | null | undefined,
  code: string | null | undefined,
): { primary: string; secondary: string | null } {
  const name = String(displayName ?? '').trim();
  const c = String(code ?? '').trim();
  const primary = name || c;
  const secondary = name && c && !isOrgSecondaryCodeRedundant(name, c) ? c : null;
  return { primary, secondary };
}
